import { createElement } from "react"
import { AppRouteConfig } from "@/types/navigation"
import Base from "@/pages/base"

import { authRoutes } from "./auth"
import { enrichmentRoutes } from "./enrichment"
import { chatRoutes } from "./chat"
import errorRoutes from "./error"
import { settingsRoutes } from "./settings"
import { organizationRoutes } from "./organization"
import { inviteRoutes } from "./invite"
import { resourceRoutes } from "./resource"
import { integrationRoutes } from "./integration"
import { boardRoutes } from "./board"
import { editorRoutes } from "./editor"

const baseRoute: AppRouteConfig[] = [
  {
    path: "/",
    element: createElement(Base),
    restricted: false,
    showNav: false,
    showSideBar: false,
  },
]

export default [
  ...authRoutes,
  ...baseRoute,
  ...enrichmentRoutes,
  ...chatRoutes,
  ...errorRoutes,
  ...settingsRoutes,
  ...organizationRoutes,
  ...inviteRoutes,
  ...resourceRoutes,
  ...integrationRoutes,
  ...boardRoutes,
  ...editorRoutes,
]
